import { render, staticRenderFns } from "./TourTabsDeparturesHistoricPanel.vue?vue&type=template&id=ef491d6e&scoped=true&"
import script from "./TourTabsDeparturesHistoricPanel.vue?vue&type=script&lang=js&"
export * from "./TourTabsDeparturesHistoricPanel.vue?vue&type=script&lang=js&"
import style0 from "./TourTabsDeparturesHistoricPanel.vue?vue&type=style&index=0&id=ef491d6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef491d6e",
  null
  
)

export default component.exports